import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getPplPlacesFetchSuccess,
    getPplPlacesFetchFailure,
    getPplPlaceByAddressIdFetchSuccess,
    getPplPlaceByAddressIdFetchFailure,
} from './reducer';
import { PplPlacesResType } from 'src/types/pplPlaces';

type GetPplPlacesPayload = {
    country: string;
    pointType?: string;
};

const getPplPlacesFetchRequest = async (payload: GetPplPlacesPayload) => {
    const { country, pointType } = payload;
    let url = 'api/secure/shippers/ppl/access-points?country=' + country;
    if (pointType) {
        url += '&type=' + pointType;
    }
    const res = await api('get', url);
    return res.data;
};

function* getPplPlacesFetch(action: { payload: GetPplPlacesPayload; type: string }) {
    try {
        const response: PplPlacesResType = yield call((): any =>
            getPplPlacesFetchRequest(action.payload)
        );

        yield put(getPplPlacesFetchSuccess(response));
    } catch (error) {
        yield put(getPplPlacesFetchFailure({ error, noMessage: true }));
    }
}

export function* getPplPlacesFetchWatch() {
    yield takeEvery('pplPlaces/getPplPlacesFetch', getPplPlacesFetch);
}

const getPplPlaceByAddressIdFetchRequest = async (addressId: string) => {
    const res = await api('get', `api/secure/shippers/ppl/access-point/${addressId}`);
    return res.data;
};

function* getPplPlaceByAddressIdFetch(action: { type: string; payload: string }): Generator<any, void, any> {
    try {
        const response: { countryCode: string } = yield call((): any =>
            getPplPlaceByAddressIdFetchRequest(action.payload)
        );

        yield put(
            getPplPlaceByAddressIdFetchSuccess({
                country: response.countryCode?.toLowerCase() || '',
                addressId: action.payload,
            })
        );
    } catch (error) {
        yield put(getPplPlaceByAddressIdFetchFailure({ error, noMessage: true }));
    }
}

export function* getPplPlaceByAddressIdFetchWatch() {
    yield takeEvery('pplPlaces/getPplPlaceByAddressIdFetch', getPplPlaceByAddressIdFetch);
}
